import { FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../../base/hooks";
import { IRadioGroupProps } from "./IRadioGroupProps";

export const RadioGroupProperties = [
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    { id: Property.Dropdown, name: 'Options', type: PropertyType.Dropdown },
    { id: Property.Required, name: 'Required', type: PropertyType.Boolean },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useRadioGroupProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IRadioGroupProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: IRadioGroupProps = {
            label: bindings.getValue(Property.Label) || '',
            value: bindings.getValue(Property.InitValue) || '',
            options: bindings.getValue(Property.Dropdown) || [],
            required: bindings.getValue(Property.Required) || false,
            disabled: bindings.getValue(Property.Disabled) || false,
            title: bindings.getValue(Property.Tooltip) || ''
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}
